module.exports = __webpack_public_path__ + "img/living_5.7534b214.jpg";